<template>
    <div>
        <SearchObject
            :additional-params="{ ordering: '-main,name', archived: false, ...additionalParams }"
            :allow-create="allowCreate"
            :autofocus="autofocus"
            :base-url="baseUrl"
            :create-label="$translate('create_an_establishment')"
            :disabled="disabled"
            :error-messages="errorMessages"
            :hide-details="hideDetails"
            :item-text="itemText"
            :label="label || $translate('select_establishment')"
            :readonly="readonly"
            :required="required"
            :value="value"
            :icon="icon"
            :flat="flat"
            :outlined="outlined"
            :background-color="backgroundColor"
            @create="createEstablishment"
            @input="$emit('input', $event)"
            @select="$emit('select', $event)"
            display="establishment"
            ref="search"
            :dense="dense"
        >
            <template slot="item" slot-scope="{ item }">
                <div class="d-flex align-center">
                    <span>{{ item.name }}</span>
                    <v-chip v-if="item.main" small color="primary" text-color="white" class="ml-2">
                        {{ $translate("main") }}
                    </v-chip>
                </div>
            </template>
        </SearchObject>
    </div>
</template>

<script>
import EstablishmentEdit from "@/modals/establishment";
import GlobalMixins from "@/mixins/global";

export default {
    mixins: [GlobalMixins],
    name: "SearchEstablishment",
    props: {
        // The base URL to fetch items from.
        baseUrl: {
            type: String,
            default: "/api/establishments/",
        },
        // Additional GET parameters to include in the API request.
        additionalParams: {
            type: Object,
            default: () => ({}),
        },
        // Whether the component is disabled.
        disabled: {
            type: Boolean,
            default: false,
        },
        // v-model binding (selected item ID).
        value: {
            type: [String, Number],
            default: null,
        },
        // Label for the autocomplete.
        label: {
            type: String,
            required: false,
        },
        // Optional limit per request.
        limit: {
            type: Number,
            default: 20,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        allowCreate: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: [Boolean, String],
            default: true,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            default: null,
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        flat: {
            type: Boolean,
            default: false,
        },
        backgroundColor: {
            type: String,
            default: null,
        },
        // Error messages to display
        errorMessages: {
            type: [String, Array],
            default: null,
        },
    },
    methods: {
        async createEstablishment() {
            const result = await this.showModal({
                component: EstablishmentEdit,
                params: {
                    establishment: {},
                },
            });
            if (result) {
                this.$emit("input", result.id || result);
                this.$refs.search.update();
            } else {
                this.$refs.search.reset();
            }
        },
        itemText(item) {
            return item.name;
        },
        focus() {
            this.$refs.search.focus();
        },
    },
    i18n: {
        messages: {
            en: {
                select_establishment: "Select an establishment",
                create_an_establishment: "Create an establishment",
                main: "Main",
            },
            fr: {
                select_establishment: "Sélectionnez un établissement",
                create_an_establishment: "Créer un établissement",
                main: "Principal",
            },
        },
    },
};
</script>

